/* eslint-disable no-unused-expressions */
import React from 'react';
import {connect} from 'react-redux';
import './CreateControl.css';
import 'react-datepicker/dist/react-datepicker.css';
import {registerLocale} from 'react-datepicker';
import pl from 'date-fns/locale/pl';
import * as actionsKinds from '../../Redux/Actions/Kinds';
import * as actionsTypes from '../../Redux/Actions/Types';
import * as actionsModes from '../../Redux/Actions/Modes';
import * as actionsProg from '../../Redux/Actions/Programs';
import * as actionsProj from '../../Redux/Actions/Projects';
import * as actionsUser from '../../Redux/Actions/Users';
import * as actionsLists from '../../Redux/Actions/ControlLists';
import * as httpService from '../HttpService/HttpService';
import * as PropertyBucket from '../../Properties/Properties.js';
import {ControlDto} from '../Dtos/ControlDto';
import {Waiter} from '../WaitingSign/Waiting';
import PopUp from '../PopUp/PopUp';
import {isURLContainString} from '../../Helpers/utils';
import {ControlForm} from './ControlForm';
import {KindListForm} from './KindListForm';
import {NewKindForm} from './NewKindForm';
import {compareByCode} from '../../Helpers/utils';

class CreateControl extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			isAllDataFetched: false,
			showPopup: false,
			popUp: null,
			currentPopup: null,
			activeKinds: [],
			userRole: localStorage.getItem('userRole'),
		};

		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Utwórz kontrolę";
		const {
			fetchProgsData,
			fetchKindsData,
			fetchTypesData,
			fetchModesData,
			fetchUsersData,
			fetchListsData,
			fetchProjData
		} = this.props;

		fetchKindsData();
		fetchTypesData();
		fetchModesData();
		fetchProjData();
		fetchProgsData();
		fetchUsersData();
		fetchListsData();

		this.isWaitingOnOff(true)
	}

	getProjects(searchText) {
		this.props.fetchProjData(searchText);
	}

	componentDidUpdate(prevProps, prevState){
		const activeKinds = this.props.kinds.kinds.filter(kind => kind.active === true);

		if (activeKinds.length !== prevState.activeKinds.length){
			this.setState({
				activeKinds
			})
		}

		if (this.props.kinds.isError && !prevProps.kinds.isError){
			this.setState({
				showPopup: true,
				popUp: {
					notification: this.props.kinds.error.message || 'Nieznany błąd.',
					type: 'error',
					title: 'Błąd'
				}
			})
		}

		else if (prevProps.kinds.isLoading === true &&
			this.props.kinds.isLoading === false &&
			this.props.kinds.isError === false &&
			this.state.activeKinds.length !== 0 &&
			this.state.userRole === 'SA' &&
			activeKinds.length !== this.state.activeKinds.length){
				this.showNotifyPopup('Dane zostały zmienione', 'Komunikat', this.showKindListForm)
		}

		if (this.allDataIsFetched() && this.state.isAllDataFetched === false){
			this.setState({
				isAllDataFetched: true
			});
			this.isWaitingOnOff(false);
		}
	}

	allDataIsFetched = () => {
		return this.props.users.isLoading === false &&
			this.props.kinds.isLoading === false &&
			this.props.types.isLoading === false &&
			this.props.modes.isLoading === false &&
			this.props.users.isLoading === false &&
			this.props.lists.isLoading === false &&
			this.props.projects.isLoading === false;


	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	handleClosePopUp() {
		this.setState({showPopup: false, currentPopup: null});
	}

	cancelSave = () => {
		this.setState({
			showPopup: true,
			popUp: {
				title: 'Ostrzeżenie',
				notification: PropertyBucket.getCancelMessage(),
				type: 'confirm',
				onClick: () => this.props.history.goBack()
			}
		})
	};

	handleSaveControl = async (values) => {

			this.isWaitingOnOff(true);

			const controlDto = new ControlDto();
		controlDto.dictionaryEntries = values.kinds;
		controlDto.dictionaryEntries.push(values.mode);
			controlDto.dictionaryEntries.push(values.type);
			controlDto.project = values.project[0];
			// controlDto.number = values.project[0].number;
			controlDto.dateFrom = values.dateFrom;
			controlDto.dateTo = values.dateTo;
			controlDto.controlStatus = 0;
			controlDto.controllers = values.controllers;
			controlDto.questionList = values.controlList[0];
			controlDto.teamLeader = values.teamLeader;
			controlDto.remarks = values.remarks;

			const url = PropertyBucket.getAddControl();

			try {
				await httpService.getServicePromise(url, 'POST', controlDto);

				this.setState({
					disabled: 'disabled',
					isWaiting: false,
					showPopup: true,
					popUp: {
						title: 'Komunikat',
						notification: PropertyBucket.createControlMessage(),
						onClick: () => {

							isURLContainString(this.props.history.location.pathname, ['create_control'])
							&& this.props.history.push('/controls/planned');

							isURLContainString(this.props.history.location.pathname, ['edit_control'])
							&& this.props.history.goBack() 
						} 
					}
				})
			} catch (error) {
				this.setState({
					showPopup: true,
					popUp: {title: 'Błąd', notification: error, type: 'error'}
				});

				this.isWaitingOnOff(false);
			}
	};

	renderUserName = (loadedUserData) => {
		for (let i = 0; i < loadedUserData.length; i++) {
			loadedUserData[i].userAllName = loadedUserData[i].userFirstName + ' ' + loadedUserData[i].userSurname;
		}
	};

	showConfirmPopup = (notification, title, onClickEvent, onClosePopup) => {
		this.setState({
			showPopup: true,
			currentPopup: 'default',
			popUp: {
				...this.state.popUp,
				notification,
				title,
				type: 'confirm',
				onClick: onClickEvent,
				closePopUp: onClosePopup
			}
		})
	};

	showNotifyPopup = (notification, title, onClick) => {
		this.setState({
			showPopup: true,
			currentPopup: 'default',
			popUp: {
				...this.state.popUp,
				type: 'notify',
				notification,
				title,
				onClick
			}
		})
	};

	showNewKindForm = () => {
		this.setState({
			showPopup: true,
			currentPopup: 'newKindForm',
			popUp: {
				...this.state.popUp,
				closePopUp: this.showKindListForm,
				title: "Dodawanie rodzaju kontroli",
				type: "custom",
			}
		})
	};

	showKindListForm = () => {
		this.setState({
			showPopup: true,
			currentPopup: 'kindListForm',
			popUp: {
				...this.state.popUp,
				closePopUp: this.handleClosePopUp,
				title: 'Rodzaj kontroli',
				type: "custom",
			}
		})
	};


	render() {
		registerLocale('pl', pl);
		let loadedUserData = this.props.users.users;
		this.renderUserName(loadedUserData);

		let notification = this.state.popUp?.notification;
		if (this.state.currentPopup === 'newKindForm'){
			notification = <NewKindForm 
								handleSaveKind={(data) => {
									this.props.saveNewKind(data)
								}}
								handleClose={() => this.showKindListForm()}
							/>
		}
		else if (this.state.currentPopup === 'kindListForm'){
			notification = <div className='popUp__content-scrolled'>
				<KindListForm 
					data={this.props.kinds.kinds}
					handleNewKind={() => this.showNewKindForm()}
					handleChangeKind={(kind, checked) => {
						this.showConfirmPopup(
							`Czy chcesz ${checked ? 'aktywować' : 'dezaktywować'} rodzaj kontroli: ${kind.description}?`,
							'Zmiana statusu',
							() => {
								this.props.updateActiveStatus(kind.entryId, checked);
								this.showKindListForm()
							},
							() => this.showKindListForm()
						)
					}}
				/>
			</div>
		}


		return (
			<div id='control_create'>
				{this.state.showPopup && (
					<PopUp type={this.state.popUp.type}
							title={this.state.popUp.title}
							link={this.state.popUp.link}
							onClickEvent={this.state.popUp.onClick}
							closePopUp={this.state.popUp.closePopUp || this.handleClosePopUp}
							notification={notification} />
					 )}

				<h2 className='mb-3'>Utwórz kontrolę</h2>

				{this.state.userRole === 'SA' && (
					<button className="btn save-btn button-align__right" onClick={() => this.showKindListForm() }>
						+ RODZAJ KONTROLI
					</button>
				)}


				<ControlForm
					projects={this.props.projects.projects || []}
					kinds={this.state.activeKinds || []}
					types={this.props.types.types || []}
					modes={this.props.modes.modes || []}
					controllers={this.props.users.users || []}
					controlLists={this.props.controlList.controlList || []}
					handleSaveControl={this.handleSaveControl}
					handleAbort={this.cancelSave}
					getProjects={(search) => this.getProjects(search)}
				/>

				<div id='waiter'>
					<Waiter loading={this.state.isWaiting} />
				</div>

			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const filterByCode = (a) => {
		const selectedProgramCode = state.programs?.selected?.code;
		if (selectedProgramCode) {
			return a.code?.startsWith(selectedProgramCode);
		}
		return true;
	};

	const filterByImplementationLevel = (a) => {
		const selectedProgramCode = state.programs?.selected?.code;
		if (selectedProgramCode) {
			return a.implementationLevel?.startsWith(selectedProgramCode);
		}
		return true;
	};

	return {
		...state,
		users: {
			...state.users,
			users: state.users.users ? state.users.users.map((user) => {
			return {
				...user,
				firstName: user.name,
				firstAndLastName: user.name + " " + user.lastName,
				customLabel: `${user.name} ${user.lastName} - ${user.administrationLogin}`,
			};
			}) : [],
		},
		controlList: {
			...state.controlList,
			controlList: state?.controlList?.controlList ? state.controlList.controlList.filter(filterByCode).map((cl) => {
				return {
					...cl,
					codeAndName: `${cl.code} - ${cl.name}`,
				};
			}).sort(compareByCode) : []
		},
		projects: {
			...state.projects,
			projects: state?.projects?.projects ? state.projects.projects.filter(filterByImplementationLevel) : []
		}
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProgsData: () => dispatch(actionsProg.getProgramsData()),
		fetchProjData: (searchText) => dispatch(actionsProj.getProjectsData(searchText)),
		fetchUsersData: () => dispatch(actionsUser.getControllersUsersData()),
		fetchListsData: () => dispatch(actionsLists.getActiveListData()),
		fetchKindsData: () => dispatch(actionsKinds.getKindsData()),
		fetchTypesData: () => dispatch(actionsTypes.getTypesData()),
		fetchModesData: () => dispatch(actionsModes.getModesData()),
		saveNewKind: (data) => dispatch(actionsKinds.saveNewKind(data)),
		updateActiveStatus: (entryId, active) => dispatch(actionsKinds.updateActiveStatus(entryId, active))
	}
};

export const CreateControlProvider = connect(mapStateToProps, mapDispatchToProps)(CreateControl);



